import { useTranslation } from "react-i18next";
import type { BillingActionError } from "@onetasklist/shared";

export interface PastDueBannerText {
  message: string;
  action: string;
  opening: string;
  portalError: (error: BillingActionError) => string;
}

export const usePastDueBannerText = (): PastDueBannerText => {
  const { t } = useTranslation();

  return {
    message: t("billing.pastDue.message"),
    action: t("billing.pastDue.action"),
    opening: t("billing.section.openingPortal"),
    portalError: (error) => t(`billing.errors.${error}`),
  };
};
